import { getParameterFromURL } from "./getParameterFromUrl";

export default function getCurrencyValue(): string {
  let currency: string;

  const subscrUK = getParameterFromURL("subscrUK");
  const subscrEU = getParameterFromURL("subscrEU");

  if (subscrUK) {
    currency = "GBP";
  } else if (subscrEU) {
    currency = "EUR";
  } else {
    currency = "USD";
  }

  return currency;
}
